/**
 * Which message an import failure deserves.
 *
 * Pure on purpose: the import hook reaches Tauri, the workspace store and the
 * sync engine, and this decision is the part worth pinning with tests.
 *
 * A plan limit is not a failure the user can retry their way out of — the file
 * is fine. "Import failed: <limit message>" is a dead end, so it names the two
 * ways forward instead: a local workspace has no cloud limits, or raise the
 * plan. The server's own sentence says WHICH limit was hit, so it leads.
 *
 * Everything else IS worth retrying — a timeout, a 500, a dropped connection —
 * and must keep reading as a failure. Dressing those up as a plan limit would
 * send someone to the pricing page over a blip.
 */

/** True when the server refused because of the account's plan, not the file. */
export function isPlanLimit(error) {
  return error?.response?.status === 402 || Boolean(error?.response?.data?.upgrade_required);
}

/**
 * @param {Error} error as thrown by collectionService.importCollections
 * @returns {{ key: string, type: string, vars: object }} arguments for toastT
 */
export function importFailureToast(error) {
  const message = error?.message || '';
  return isPlanLimit(error)
    ? { key: 'toast.importPlanLimit', type: 'warning', vars: { reason: message } }
    : { key: 'toast.importCollectionFailed', type: 'error', vars: { message } };
}
